var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("crear-actualizar-persona"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-tabs",
            {
              attrs: {
                centered: "",
                color: "primary",
                dark: "",
                "icons-and-text": ""
              }
            },
            [
              _c("v-tabs-slider", { attrs: { color: "cyan" } }),
              _vm._v(" "),
              this.$util.permisoRol([32, 117])
                ? _c("v-tab", { attrs: { href: "#tab-1" } }, [
                    _vm._v("\n        Servidores públicos\n        "),
                    _c("span", { staticClass: "material-symbols-outlined" }, [
                      _vm._v("\n          person\n        ")
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.$util.permisoRol([128])
                ? _c("v-tab", { attrs: { href: "#tab-2" } }, [
                    _vm._v("\n        Pasantes\n        "),
                    _c("span", { staticClass: "material-symbols-outlined" }, [
                      _vm._v("\n          school\n        ")
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-tab-item",
                { attrs: { value: "tab-1" } },
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c("h3", { staticClass: "primary--text" }, [
                            _c(
                              "span",
                              { staticClass: "material-symbols-outlined" },
                              [
                                _vm._v(
                                  "\n                person\n              "
                                )
                              ]
                            ),
                            _vm._v(
                              "\n              Servidores públicos\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("ListadoPersona", {
                            attrs: { l_id_tipo_persona: [1] }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tab-item",
                { attrs: { value: "tab-2" } },
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c("h3", { staticClass: "primary--text" }, [
                            _c(
                              "span",
                              { staticClass: "material-symbols-outlined" },
                              [
                                _vm._v(
                                  "\n                school\n              "
                                )
                              ]
                            ),
                            _vm._v("\n              Pasantes\n            ")
                          ]),
                          _vm._v(" "),
                          _c("ListadoPersona", {
                            attrs: { l_id_tipo_persona: [3] }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c4c2722", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c4c2722","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/persona/Index.vue
// module id = null
// module chunks = 